import React, { useRef, useEffect, useState } from "react";
import thumbsup from "../../assets/thumbsup.svg";
import thumbsdown from "../../assets/thumbsdown.svg";
import UnlikeModal from "../UnlikeModal/UnlikeModal";
import logo from "../../assets/logo.png";
import "./Question.css";
import { Configuration, OpenAIApi } from "openai";
import ChatInput from "../ChatInput/ChatInput";
import Swal from "sweetalert2";

const configuration = new Configuration({
  apiKey: "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",
});
const openai = new OpenAIApi(configuration);

const ChatCard = ({ content, role, handleShowModal, index, user }) => {
  if (role === "user") {
    return (
      <div>
        {" "}
        <div className=" w-full h-fit mx-auto mt-10">
          <div className="bg-transparent border-2 border-green-900 border-r-0 border-l-0 p-5 ">
            <div className="w-full mx-auto flex ">
              <img
                alt="profilepic"
                className="w-10 rounded-sm h-10 mr-5 bg-no-repeat bg-center bg-cover object-cover"
                // src="https://www.themoviedb.org/t/p/w500/52GxBTYdLLc3x3UVSplZdHqj4RR.jpg"
                src={user?.picture}
              ></img>
              <h1 className="text-sm md:text-md lg:text-lg"> {content}</h1>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className=" w-full mx-auto">
        <div className="bg-transparent p-5 ">
          <div className="w-full mx-auto">
            <div className="flex flex-col">
              {content
                .replace("/\t/", "&nbsp;&nbsp;&nbsp;&nbsp;")
                .split(/\n/)
                .map((item) => (
                  <p className="text-sm md:text-md text-justify lg:text-lg">{item}</p>
                ))}
            </div>
            <div className="flex gap-2 mt-5 w-full">
              <p className="text-gray-300">Do you agree with the answer?</p>
              <img
                alt="thumbsup"
                className="w-6 cursor-pointer"
                src={thumbsup}
              ></img>
              <img
                alt="thumbsdown"
                className="w-6 cursor-pointer"
                src={thumbsdown}
                onClick={() => handleShowModal(index)}
              ></img>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

function Question({ user }) {
  const [currentQuestion, setCurrentQuestion] = useState("");
  const [qAndAPairs, setQAndAPairs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [givenAnswer, setGivenAnswer] = useState("");
  const [givenQuestion, setGivenQuestion] = useState("");

  useEffect(() => {
    getPreviousQAndAPairs();
  }, []);

  const getPreviousQAndAPairs = () => {
    const previousQAndAPairs = localStorage.getItem("qAndAPairs");
    if (previousQAndAPairs) {
      setQAndAPairs([...JSON.parse(previousQAndAPairs)]);
    } else {
      setQAndAPairs([]);
    }
  };

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [qAndAPairs]);

  const handleGptAPI = async () => {
    try {
      Swal.fire({
        background: "transparent",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      setLoading(true);
      const newMessageArray = [
        ...qAndAPairs,
        {
          role: "user",
          content: currentQuestion,
        },
      ];
      console.log(newMessageArray);
      const response = await openai.createChatCompletion({
        model: "gpt-3.5-turbo",
        messages: newMessageArray,
      });
      console.log(response.data.choices);
      const newSetOfQAndAPairs = [
        ...newMessageArray,
        {
          ...response.data.choices[0].message,
        },
      ];
      setQAndAPairs((p) => newSetOfQAndAPairs);
      localStorage.setItem("qAndAPairs", JSON.stringify(newSetOfQAndAPairs));
    } catch (error) {
      Swal.fire({
        title: "Error!",
        background: "black",
        text: "An error occurred.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      Swal.close();
      setCurrentQuestion("");
      setLoading(false);
    }
  };
  const handleShowModal = (index) => {
    const question = qAndAPairs[index - 1].content;
    const givenAnswer = qAndAPairs[index].content;
    setShowModal(true);
    setGivenQuestion(question);
    setGivenAnswer(givenAnswer);
  };

  const handleHideModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <div>
        <div className="overflow-x-clip h-[70vh] overflow-y-auto">
          {qAndAPairs.length === 0 && (
            <div className="flex flex-col items-center justify-center p-10 h-full">
              <img alt="logo" className="h-[30vh]" src={logo}></img>
              <p className="text-gray-300 text-lg text-center mt-5">
                Welcome to FitAIG program, please ask me anything about fitness
                and correct the answer (if I'm wrong).
              </p>
            </div>
          )}
          {qAndAPairs.map(({ content, role }, index) => (
            <>
              <ChatCard
                index={index}
                role={role}
                user={user}
                content={content}
                handleShowModal={(index) => handleShowModal(index)}
              />
              <div ref={messagesEndRef}></div>
            </>
          ))}
        </div>
        <div className="ChatInput  ">
          <ChatInput
            value={currentQuestion}
            onChange={(val) => setCurrentQuestion(val)}
            onSubmit={handleGptAPI}
          />
        </div>
      </div>
      {showModal && (
        <div className="unlikeModal   ">
          <UnlikeModal
            givenAnswer={givenAnswer}
            givenQuestion={givenQuestion}
            handleHideModal={handleHideModal}
          />
        </div>
      )}
    </>
  );
}

export default Question;
